import "./formulaireAbsence.css";
import React, { useState, useRef, useCallback, useEffect } from "react";
import FormConfirmation from "./components/FormConfirmation";
import Select from "react-select";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import schools from "./schools.json"; // Assuming you have a JSON file with school
import { Link } from "react-router-dom";
import RadioButton from "./components/RadioButton"; // Import the RadioButton component
import { motion } from "framer-motion";
import SundayCalendarComp from "./components/SundayCalendarComp"; // Calendar starting on Sunday
import EmailVerification from "./components/EmailVerification";

function CongeDroitParentaux() {
  useEffect(() => {
    document.title = "SEVF | Droits parentaux";
  }, []);

  const [form_Data, set_Form_Data] = useState({
    firstName: "",
    lastName: "",
    establishment: "",
    matricule: "",
    phoneNumber: "",
    requestType: "",
    congeOption: "",
    startDate: "",
    endDate: "",
    estivaleOuRelache: "",
    regimeType: "",
    prolongation: "",
    prolongationStartDate: "",
    prolongationEndDate: "",
    prolongationOptions: "",
    emailVerified: false,
    emailToVerify: "",
  });

  const initialFormData = {
    firstName: "",
    lastName: "",
    establishment: "",
    matricule: "",
    phoneNumber: "",
    requestType: "",
    congeOption: "",
    startDate: "",
    endDate: "",
    estivaleOuRelache: "",
    regimeType: "",
    prolongation: "",
    prolongationStartDate: "",
    prolongationEndDate: "",
    prolongationOptions: "",
    emailVerified: false,
    emailToVerify: "",
  };

  const apiUrl = process.env.REACT_APP_API_URL;

  const [submittedData, setSubmittedData] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formValidated, setFormValidated] = useState(false);
  const [firstFormValidation, setFirstFormValidation] = useState(false);
  const [acknowledgeSignature, setAcknowledgeSignature] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);

  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const establishmentRef = useRef(null);
  const matriculeRef = useRef(null);
  const phoneRef = useRef(null);
  const requestTypeRef = useRef(null);
  const congeOptionRef = useRef(null);
  const estivaleOuRelacheRef = useRef(null);
  const dateRef = useRef(null);
  const prolongationOptionRef = useRef(null);
  const prolongationDateRef = useRef(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      if (firstFormValidation) {
        setFormErrors(validateFormData(updatedData, acknowledgeSignature));
      }
      return updatedData;
    });
  };

  const handleProlongationChange = (event) => {
    const { value } = event.target;
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        prolongation: value,
        prolongationOptions: "",
      };
      if (firstFormValidation) {
        setFormErrors(validateFormData(updatedData, acknowledgeSignature));
      }
      return updatedData;
    });
  };

  const handleCongeOptionChange = (event) => {
    const { value } = event.target;
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        congeOption: value,
        startDate: "",
        endDate: "",
        estivaleOuRelache: "",
        regimeType: "",
        prolongation: "",
        prolongationOptions: "",
        prolongationStartDate: "",
        prolongationEndDate: "",
      };
      if (firstFormValidation) {
        setFormErrors(validateFormData(updatedData, acknowledgeSignature));
      }
      return updatedData;
    });
  };

  const handleRequestTypeChange = (event) => {
    const { value } = event.target;
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        requestType: value,
        congeOption: "",
        startDate: "",
        endDate: "",
        estivaleOuRelache: "",
        regimeType: "",
        prolongation: "",
        prolongationOptions: "",
        prolongationStartDate: "",
        prolongationEndDate: "",
      };
      if (firstFormValidation) {
        setFormErrors(validateFormData(updatedData, acknowledgeSignature));
      }
      return updatedData;
    });
  };

  const validateFormData = (form_Data, acknowledgeSignature) => {
    const errors = {};

    // Validate firstName
    if (!form_Data.firstName) {
      errors.firstName = "Le prénom est requis.";
    } else if (/\d/.test(form_Data.firstName)) {
      errors.firstName = "Le prénom ne doit pas contenir de chiffres.";
    }

    // Validate lastName
    if (!form_Data.lastName) {
      errors.lastName = "Le nom est requis.";
    } else if (/\d/.test(form_Data.lastName)) {
      errors.lastName = "Le nom ne doit pas contenir de chiffres.";
    }

    // Validate establishment
    if (!form_Data.establishment) {
      errors.establishment = "Le nom de l'école est requis.";
    }

    // Validate matricule
    if (!form_Data.matricule) {
      errors.matricule = "Le numéro de matricule est requis.";
    } else if (form_Data.matricule.length > 7) {
      errors.matricule =
        "Le numéro de matricule ne doit pas dépasser 7 chiffres.";
    }

    // Validate phoneNumber
    if (!form_Data.phoneNumber) {
      errors.phoneNumber = "Le numéro de téléphone est requis.";
    } else if (form_Data.phoneNumber.length !== 12) {
      errors.phoneNumber = "Le numéro de téléphone doit contenir 10 chiffres.";
    }

    // Validate requestType
    if (!form_Data.requestType) {
      errors.requestType = "Veuillez sélectionner un type de demande.";
    }

    // Validate congeOption
    if (!form_Data.congeOption) {
      errors.congeOption = "Veuillez sélectionner une option de congé.";
    }

    // Skip date, estivale/relâche, and régime validation for options that skip to prolongation
    if (
      form_Data.congeOption !== "ModificationProlongationMaternite" &&
      form_Data.congeOption !== "ProlongationPaternite" &&
      form_Data.congeOption !== "ModificationProlongationAdoption"
    ) {
      // Validate startDate
      if (!form_Data.startDate) {
        errors.date = "La date de début du congé est requise.";
      }
      // Validate endDate
      if (!form_Data.endDate) {
        errors.date = "La date de fin du congé est requise.";
      } else if (form_Data.startDate && form_Data.endDate) {
        const startDate = new Date(form_Data.startDate);
        const endDate = new Date(form_Data.endDate);
        if (startDate >= endDate) {
          errors.date =
            "La date de fin doit être postérieure à la date de début.";
        }
      }

      // Validiate if both dates are missing
      if (!form_Data.startDate && !form_Data.endDate) {
        errors.date =
          "Veuillez sélectionner les dates de début et de fin du congé.";
      }

      // Validate estivaleOuRelache
      if (!form_Data.estivaleOuRelache) {
        errors.estivaleOuRelache =
          "Veuillez choisir si le congé coïncide avec la période estivale ou la semaine de relâche.";
      }

      // Validate regimeType
      if (!form_Data.regimeType) {
        errors.regimeType = "Veuillez sélectionner un type de régime.";
      }
    }

    if (!acknowledgeSignature) {
      errors.acknowledgeSignature =
        "Veuillez cocher la case pour accepter les avertissements.";
    }

    if (!emailVerified) {
      errors.emailVerified = "Veuillez vérifier votre adresse e-mail.";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFormData(form_Data, acknowledgeSignature);

    if (!firstFormValidation) {
      setFirstFormValidation(true);
    }

    if (Object.keys(errors).length === 0) {
      setFormValidated(true);
      setFormErrors({});

      try {
        setSubmitError(null);
        setLoading(true);
        // Create a FormData instance and append all fields
        const formDataToSend = new FormData();
        for (const key in form_Data) {
          if (key === "file" && form_Data.file) {
            formDataToSend.append("file", form_Data.file);
          } else {
            formDataToSend.append(key, form_Data[key]);
          }
        }

        // Submit the form data as multipart/form-data
        const response = await fetch(`${apiUrl}/document/parental-leave`, {
          method: "POST",
          // Do NOT set the Content-Type header manually.
          body: formDataToSend,
        });
        if (!response.ok) {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            const errorData = await response.json();
            const messages = errorData.errors?.join(" ") || "Une erreur s'est produite.";
            throw new Error(messages);
          }
          throw new Error("Une erreur s'est produite.");
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          await response.json();
        } else {
          await response.text();
        }

        // Capture data for confirmation screen before resetting
        const requestTypeLabels = {
          maternite: "Congé de maternité",
          paternite: "Congé de paternité / parent n'ayant pas donné naissance",
          adoption: "Congé d'adoption",
        };
        const formatDate = (d) =>
          d ? new Date(d).toLocaleDateString("fr-CA") : null;
        const captured = {
          name: `${form_Data.firstName} ${form_Data.lastName}`,
          matricule: form_Data.matricule,
          establishment: form_Data.establishment,
          requestType:
            requestTypeLabels[form_Data.requestType] || form_Data.requestType,
          period:
            form_Data.startDate && form_Data.endDate
              ? `${formatDate(form_Data.startDate)} — ${formatDate(form_Data.endDate)}`
              : "—",
          dateSent: new Date().toLocaleString("fr-CA", {
            dateStyle: "long",
            timeStyle: "short",
          }),
        };

        // Reset the form state
        set_Form_Data(initialFormData);
        setAcknowledgeSignature(false);
        setFirstFormValidation(false);

        setFormValidated(false);
        setFormErrors({});

        setSubmittedData(captured);
      } catch (error) {
        console.error("Error:", error);
        setSubmitError(
          error.message && error.message !== "Failed to fetch"
            ? error.message
            : "Une erreur s'est produite. Veuillez réessayer. Si le problème persiste, veuillez contacter valeriec@sevf.ca.",
        );
      } finally {
        setLoading(false);
      }
    } else {
      setFormErrors(errors);

      setFormValidated(true);

      if (errors.firstName) {
        firstNameRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.lastName) {
        lastNameRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.establishment) {
        establishmentRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.matricule) {
        matriculeRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.phoneNumber) {
        phoneRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.requestType) {
        requestTypeRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.congeOption) {
        congeOptionRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.date && dateRef.current) {
        dateRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.estivaleOuRelache && estivaleOuRelacheRef.current) {
        estivaleOuRelacheRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const handlePhoneChange = (value) => {
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, phoneNumber: value };
      if (firstFormValidation) {
        setFormErrors(validateFormData(updatedData, acknowledgeSignature));
      }
      return updatedData;
    });
  };

  const handleAcknowledgeSignatureChange = (e) => {
    const newVal = e.target.checked;
    setAcknowledgeSignature(newVal);
    if (firstFormValidation) {
      const updatedErrors = validateFormData(form_Data, newVal);
      setFormErrors(updatedErrors);
    }
  };

  const handleEmailVerified = useCallback((email) => {
    setEmailVerified(true);
    set_Form_Data((prev) => ({
      ...prev,
      emailVerified: true,
      emailToVerify: email,
    }));
    setFormErrors((prev) => ({
      ...prev,
      emailVerified: undefined,
    }));
  }, []);

  const modernSelectStyles = (hasError, isValid) => ({
    control: (base, state) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderColor: hasError ? "#ba1a1a" : isValid ? "#198754" : "#e2e4ea",
      borderWidth: "1.5px",
      borderRadius: "0.5rem",
      boxShadow: state.isFocused
        ? `0 0 0 3px ${hasError ? "rgba(186,26,26,0.15)" : "rgba(0,68,127,0.15)"}`
        : "0 1px 3px rgba(0,0,0,0.08)",
      minHeight: "44px",
      "&:hover": {
        borderColor: hasError ? "#ba1a1a" : isValid ? "#198754" : "#c2c7d0",
      },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: "0.5rem",
      border: "1.5px solid #e2e4ea",
      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#00447f"
        : state.isFocused
          ? "#f2f3fe"
          : "transparent",
      color: state.isSelected ? "#ffffff" : "#181c23",
    }),
    singleValue: (base) => ({ ...base, color: "#181c23" }),
    placeholder: (base) => ({ ...base, color: "#9da3ae" }),
  });

  const inputStyle = (hasError, isValid) => ({
    width: "100%",
    padding: "0.75rem",
    border: `1.5px solid ${hasError ? "#ba1a1a" : isValid ? "#198754" : "#e2e4ea"}`,
    borderRadius: "0.5rem",
    fontSize: "0.95rem",
    outline: "none",
    backgroundColor: "#ffffff",
    color: "#181c23",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    fontFamily: "Inter, sans-serif",
    boxSizing: "border-box",
  });

  const labelStyle = {
    display: "block",
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#414751",
    marginBottom: "0.4rem",
  };

  const errorStyle = {
    color: "#ba1a1a",
    fontSize: "0.8rem",
    marginTop: "0.35rem",
    margin: 0,
  };

  const sectionBadge = (n) => (
    <div
      style={{
        width: "2rem",
        height: "2rem",
        borderRadius: "50%",
        backgroundColor: "#00447f",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.875rem",
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      {n}
    </div>
  );

  const sectionHeader = (n, title) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        marginBottom: "1.5rem",
      }}
    >
      {sectionBadge(n)}
      <h2
        style={{
          fontSize: "1.05rem",
          fontWeight: 700,
          color: "#181c23",
          margin: 0,
        }}
      >
        {title}
      </h2>
    </div>
  );

  if (submittedData) {
    return (
      <FormConfirmation
        headerTitle="Demande de congé parental"
        headerSub="Demande de congé de maternité, de paternité (ou du parent qui n'a pas donné naissance) ou d'adoption."
        dateSent={submittedData.dateSent}
        details={[
          { label: "Employé(e)", value: submittedData.name },
          { label: "Matricule", value: submittedData.matricule },
          { label: "Établissement", value: submittedData.establishment },
          { label: "Type de congé", value: submittedData.requestType },
          {
            label: "Période visée",
            value: submittedData.period,
            icon: "calendar_today",
          },
        ]}
      />
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f9f9ff",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #00447f 0%, #0066cc 100%)",
          padding: "1.25rem 1.5rem",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          flexWrap: "wrap",
          boxShadow: "0 2px 12px rgba(0,68,127,0.18)",
        }}
      >
        <Link to="/">
          <img
            src="logo.jpg"
            alt="logo"
            style={{
              maxHeight: "56px",
              width: "auto",
              borderRadius: "0.5rem",
              backgroundColor: "rgba(255,255,255,0.95)",
              padding: "0.25rem",
              flexShrink: 0,
            }}
          />
        </Link>
        <div style={{ minWidth: 0 }}>
          <h1
            style={{
              color: "#ffffff",
              fontSize: "1.2rem",
              fontWeight: 700,
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            DEMANDE DE CONGÉ PARENTAL
          </h1>
          <p
            style={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "0.85rem",
              margin: "0.25rem 0 0 0",
            }}
          >
            Demande de congé de maternité, de paternité (ou du parent qui n'a
            pas donné naissance) ou d'adoption.
          </p>
        </div>
      </div>

      <div
        style={{ maxWidth: "860px", margin: "0 auto", padding: "2rem 1.5rem" }}
      >
        {/* Remarques banner */}
        <div
          style={{
            backgroundColor: "#e8f0fe",
            borderRadius: "0.75rem",
            padding: "1.5rem 1.75rem",
            marginBottom: "2rem",
            border: "1px solid #c5d8fc",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "0.75rem",
              alignItems: "flex-start",
            }}
          >
            <span
              className="material-symbols-outlined"
              style={{
                color: "#00447f",
                fontSize: "1.4rem",
                marginTop: "0.1rem",
                flexShrink: 0,
              }}
            >
              info
            </span>
            <div>
              <p
                style={{
                  fontWeight: 700,
                  color: "#00447f",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem",
                }}
              >
                Remarques importantes
              </p>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: "1.25rem",
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                <li
                  style={{
                    color: "#1a3a5c",
                    fontSize: "0.875rem",
                    lineHeight: 1.5,
                  }}
                >
                  Veuillez respecter la date limite pour transmettre votre
                  demande.
                </li>
                <li
                  style={{
                    color: "#1a3a5c",
                    fontSize: "0.875rem",
                    lineHeight: 1.5,
                  }}
                >
                  Assurez-vous d'avoir pris contact avec Karine Dion (
                  <a href="mailto:Karined@sevf.ca" style={{ color: "#00447f" }}>
                    Karined@sevf.ca
                  </a>
                  ) avant de compléter ce formulaire.
                </li>
                <li
                  style={{
                    color: "#1a3a5c",
                    fontSize: "0.875rem",
                    lineHeight: 1.5,
                  }}
                >
                  Suite à la transmission de votre demande, le Centre de service
                  en fera l'analyse et vous rendra une décision.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <form noValidate onSubmit={handleSubmit} id="form-container">
          {/* Section 1: Informations personnelles */}
          <section
            style={{
              backgroundColor: "#f2f3fe",
              borderRadius: "0.75rem",
              padding: "2rem",
              marginBottom: "1.5rem",
            }}
          >
            {sectionHeader(1, "Informations personnelles")}
            <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: "1.25rem" }}>
              <div ref={firstNameRef}>
                <label htmlFor="firstName" style={labelStyle}>
                  Prénom
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={form_Data.firstName}
                  onChange={handleChange}
                  style={inputStyle(
                    formErrors.firstName,
                    formValidated && !formErrors.firstName,
                  )}
                />
                {formErrors.firstName && (
                  <p style={errorStyle}>{formErrors.firstName}</p>
                )}
              </div>
              <div ref={lastNameRef}>
                <label htmlFor="lastName" style={labelStyle}>
                  Nom
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={form_Data.lastName}
                  onChange={handleChange}
                  style={inputStyle(
                    formErrors.lastName,
                    formValidated && !formErrors.lastName,
                  )}
                />
                {formErrors.lastName && (
                  <p style={errorStyle}>{formErrors.lastName}</p>
                )}
              </div>
            </div>

            <div style={{ marginTop: "1.25rem" }} ref={establishmentRef}>
              <label htmlFor="establishment" style={labelStyle}>
                Nom de l'école ou du centre
              </label>
              <Select
                id="establishment"
                name="establishment"
                options={schools
                  .sort((a, b) => a.number - b.number)
                  .map((school) => ({
                    value: `${school.number} ${school.name}`,
                    label: `${school.number} ${school.name}`,
                  }))}
                value={
                  form_Data.establishment
                    ? {
                        value: form_Data.establishment,
                        label: form_Data.establishment,
                      }
                    : null
                }
                onChange={(selectedOption) => {
                  const value = selectedOption ? selectedOption.value : "";
                  set_Form_Data((prevData) => {
                    const updatedData = {
                      ...prevData,
                      establishment: value,
                    };
                    if (firstFormValidation) {
                      setFormErrors(
                        validateFormData(updatedData, acknowledgeSignature),
                      );
                    }
                    return updatedData;
                  });
                }}
                placeholder="Rechercher une école..."
                styles={modernSelectStyles(
                  formErrors.establishment,
                  formValidated && !formErrors.establishment,
                )}
              />
              {formErrors.establishment && (
                <p style={errorStyle}>{formErrors.establishment}</p>
              )}
            </div>

            <div
              className="form-grid-2"
              style={{ gap: "1.25rem", marginTop: "1.25rem" }}
            >
              <div ref={matriculeRef}>
                <label htmlFor="matricule" style={labelStyle}>
                  Numéro de matricule
                </label>
                <input
                  type="number"
                  id="matricule"
                  name="matricule"
                  value={form_Data.matricule}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  style={inputStyle(
                    formErrors.matricule,
                    formValidated && !formErrors.matricule,
                  )}
                />
                {formErrors.matricule && (
                  <p style={errorStyle}>{formErrors.matricule}</p>
                )}
              </div>
              <div ref={phoneRef}>
                <label
                  style={{
                    ...labelStyle,
                    color: formErrors.phoneNumber
                      ? "#ba1a1a"
                      : formValidated && !formErrors.phoneNumber
                        ? "#198754"
                        : "#414751",
                  }}
                >
                  Numéro de téléphone
                </label>
                <div
                  style={{
                    border: `1.5px solid ${formErrors.phoneNumber ? "#ba1a1a" : formValidated && !formErrors.phoneNumber ? "#198754" : "#e2e4ea"}`,
                    borderRadius: "0.5rem",
                    padding: "0.625rem 0.75rem",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                >
                  <PhoneInput
                    defaultCountry="CA"
                    placeholder="XXX-XXX-XXXX"
                    value={form_Data.phoneNumber}
                    onChange={handlePhoneChange}
                    name="phoneNumber"
                  />
                </div>
                {formErrors.phoneNumber && (
                  <p style={errorStyle}>{formErrors.phoneNumber}</p>
                )}
              </div>
            </div>
          </section>

          {/* Section 2: Type de demande — icon cards */}
          <section
            ref={requestTypeRef}
            style={{
              backgroundColor: "#f2f3fe",
              borderRadius: "0.75rem",
              padding: "2rem",
              marginBottom: "1.5rem",
            }}
          >
            {sectionHeader(2, "Cette demande de congé est reliée à :")}
            <div className="form-grid-3" style={{ gap: "1rem" }}>
              {[
                {
                  id: "requestTypeMaternite",
                  value: "maternite",
                  icon: "pregnant_woman",
                  label: "La maternité",
                  sublabel: "Congé de maternité",
                },
                {
                  id: "requestTypePaternite",
                  value: "paternite",
                  icon: "man",
                  label: "La paternité",
                  sublabel:
                    "Congé de paternité ou pour le parent qui n’a pas donné naissance",
                },
                {
                  id: "requestTypeAdoption",
                  value: "adoption",
                  icon: "family_restroom",
                  label: "L’adoption",
                  sublabel: "Congé d’adoption",
                },
              ].map((opt) => {
                const isSelected = form_Data.requestType === opt.value;
                return (
                  <label
                    key={opt.id}
                    htmlFor={opt.id}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      height: "100%",
                    }}
                  >
                    <input
                      type="radio"
                      id={opt.id}
                      name="requestType"
                      value={opt.value}
                      checked={isSelected}
                      onChange={handleRequestTypeChange}
                      style={{ display: "none" }}
                    />
                    <div
                      style={{
                        padding: "1.5rem",
                        borderRadius: "0.75rem",
                        flex: 1,
                        backgroundColor: isSelected
                          ? "rgba(0,68,127,0.08)"
                          : "#ecedf8",
                        border: isSelected
                          ? "2px solid #00447f"
                          : formErrors.requestType
                            ? "2px solid #ba1a1a"
                            : "2px solid transparent",
                        transition: "all 0.15s ease",
                      }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{
                          color: "#00447f",
                          fontSize: "1.75rem",
                          display: "block",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {opt.icon}
                      </span>
                      <p
                        style={{
                          fontWeight: 700,
                          color: "#181c23",
                          marginBottom: "0.25rem",
                          fontSize: "0.95rem",
                        }}
                      >
                        {opt.label}
                      </p>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          color: "#414751",
                          margin: 0,
                        }}
                      >
                        {opt.sublabel}
                      </p>
                    </div>
                  </label>
                );
              })}
            </div>
            {formErrors.requestType && (
              <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                {formErrors.requestType}
              </p>
            )}
          </section>

          {/* Section 3: Option de congé */}
          {form_Data.requestType && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              ref={congeOptionRef}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
                border: formErrors.congeOption ? "1.5px solid #ba1a1a" : "none",
              }}
            >
              {sectionHeader(3, "Cette demande concerne :")}
              {form_Data.requestType === "maternite" && (
                <>
                  <RadioButton
                    id="CongeMaternite"
                    name="congeOption"
                    label="Une demande initiale d’un congé de maternité"
                    checked={form_Data.congeOption === "CongeMaternite"}
                    onChange={handleCongeOptionChange}
                    value="CongeMaternite"
                  />
                  <RadioButton
                    id="ModificationCongeMaternite"
                    name="congeOption"
                    label="Modification d’une demande déjà complétée d’un congé de maternité"
                    checked={
                      form_Data.congeOption === "ModificationCongeMaternite"
                    }
                    onChange={handleCongeOptionChange}
                    value="ModificationCongeMaternite"
                  />
                  <RadioButton
                    id="ModificationProlongationMaternite"
                    name="congeOption"
                    label="La modification d’une demande de prolongation du congé de maternité"
                    checked={
                      form_Data.congeOption ===
                      "ModificationProlongationMaternite"
                    }
                    onChange={handleCongeOptionChange}
                    value="ModificationProlongationMaternite"
                  />
                </>
              )}
              {form_Data.requestType === "paternite" && (
                <>
                  <RadioButton
                    id="CongePaternite"
                    name="congeOption"
                    label="Une demande initale d’un congé de paternité ou d’un congé pour le parent qui n’a pas donné naissance"
                    checked={form_Data.congeOption === "CongePaternite"}
                    onChange={handleCongeOptionChange}
                    value="CongePaternite"
                  />
                  <RadioButton
                    id="ModificationCongePaternite"
                    name="congeOption"
                    label="Modification d’une demande déjà complétée d’un congé de paternité ou d’un congé pour le parent qui n’a pas donné naissance"
                    checked={
                      form_Data.congeOption === "ModificationCongePaternite"
                    }
                    onChange={handleCongeOptionChange}
                    value="ModificationCongePaternite"
                  />
                  <RadioButton
                    id="ProlongationPaternite"
                    name="congeOption"
                    label="Une demande de prolongation sans traitement d’un congé de paternité ou d’un congé pour le parent qui n’a pas donné naissance"
                    checked={form_Data.congeOption === "ProlongationPaternite"}
                    onChange={handleCongeOptionChange}
                    value="ProlongationPaternite"
                  />
                </>
              )}
              {form_Data.requestType === "adoption" && (
                <>
                  <RadioButton
                    id="CongeAdoption"
                    name="congeOption"
                    label="Une demande initale d’un congé d’adoption"
                    checked={form_Data.congeOption === "CongeAdoption"}
                    onChange={handleCongeOptionChange}
                    value="CongeAdoption"
                  />
                  <RadioButton
                    id="ModificationCongeAdoption"
                    name="congeOption"
                    label="Modification d’une demande déjà complétée d’un congé d’adoption"
                    checked={
                      form_Data.congeOption === "ModificationCongeAdoption"
                    }
                    onChange={handleCongeOptionChange}
                    value="ModificationCongeAdoption"
                  />
                  <RadioButton
                    id="ModificationProlongationAdoption"
                    name="congeOption"
                    label="La modification d’une demande de prolongation du congé d’adoption"
                    checked={
                      form_Data.congeOption ===
                      "ModificationProlongationAdoption"
                    }
                    onChange={handleCongeOptionChange}
                    value="ModificationProlongationAdoption"
                  />
                </>
              )}
              {formErrors.congeOption && (
                <p style={errorStyle}>{formErrors.congeOption}</p>
              )}
            </motion.section>
          )}

          {/* Section 4: Dates du congé */}
          {form_Data.congeOption &&
            form_Data.congeOption !== "ModificationProlongationMaternite" &&
            form_Data.congeOption !== "ProlongationPaternite" &&
            form_Data.congeOption !== "ModificationProlongationAdoption" && (
              <motion.section
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                ref={dateRef}
                style={{
                  backgroundColor: "#f2f3fe",
                  borderRadius: "0.75rem",
                  padding: "2rem",
                  marginBottom: "1.5rem",
                  border: formErrors.date ? "1.5px solid #ba1a1a" : "none",
                }}
              >
                {sectionHeader(4, "Dates du congé")}
                <div className="form-grid-2" style={{ gap: "1.5rem" }}>
                  <div>
                    <p style={{ ...labelStyle, marginBottom: "0.6rem" }}>
                      Début du congé
                    </p>
                    <SundayCalendarComp
                      onChange={(date) =>
                        set_Form_Data((prevData) => ({
                          ...prevData,
                          startDate: date,
                        }))
                      }
                    />
                  </div>
                  <div>
                    <p style={{ ...labelStyle, marginBottom: "0.6rem" }}>
                      Fin du congé
                    </p>
                    <SundayCalendarComp
                      onChange={(date) =>
                        set_Form_Data((prevData) => ({
                          ...prevData,
                          endDate: date,
                        }))
                      }
                    />
                  </div>
                </div>
                {formErrors.date && (
                  <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                    {formErrors.date}
                  </p>
                )}
              </motion.section>
            )}

          {/* Section 5: Estivale ou Relâche */}
          {form_Data.startDate && form_Data.endDate && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              ref={estivaleOuRelacheRef}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
                border: formErrors.estivaleOuRelache
                  ? "1.5px solid #ba1a1a"
                  : "none",
              }}
            >
              {sectionHeader(
                5,
                "Ce congé coïncide-t-il avec l’été ou la semaine de relâche ?",
              )}
              <RadioButton
                id="estivaleOuRelacheOui"
                name="estivaleOuRelache"
                label="Oui"
                checked={form_Data.estivaleOuRelache === "oui"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    estivaleOuRelache: e.target.value,
                  }))
                }
                value="oui"
              />
              <RadioButton
                id="estivaleOuRelacheNon"
                name="estivaleOuRelache"
                label="Non"
                checked={form_Data.estivaleOuRelache === "non"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    estivaleOuRelache: e.target.value,
                  }))
                }
                value="non"
              />
              {formErrors.estivaleOuRelache && (
                <p style={errorStyle}>{formErrors.estivaleOuRelache}</p>
              )}
            </motion.section>
          )}

          {/* Section 6: Type de régime */}
          {form_Data.estivaleOuRelache && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
                border: formErrors.regimeType ? "1.5px solid #ba1a1a" : "none",
              }}
            >
              {sectionHeader(6, "Quel type de régime prenez-vous ?")}
              <RadioButton
                id="RegimeDeBase"
                name="regimeType"
                label="Régime de base"
                checked={form_Data.regimeType === "regimeDeBase"}
                onChange={handleChange}
                value="regimeDeBase"
              />
              <RadioButton
                id="RegimeParticulier"
                name="regimeType"
                label="Régime particulier"
                checked={form_Data.regimeType === "regimeParticulier"}
                onChange={handleChange}
                value="regimeParticulier"
              />
              {formErrors.regimeType && (
                <p style={errorStyle}>{formErrors.regimeType}</p>
              )}
            </motion.section>
          )}

          {/* Section 7: Prolongation question */}
          {form_Data.regimeType && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
              }}
            >
              {sectionHeader(
                7,
                `Souhaitez-vous faire une demande de congé sans traitement en prolongation de votre congé ${form_Data.requestType === "adoption" ? "d’adoption" : form_Data.requestType ? `de ${form_Data.requestType}` : ""} ?`,
              )}
              <RadioButton
                id="prolongationOui"
                name="prolongation"
                label="Oui"
                checked={form_Data.prolongation === "oui"}
                onChange={handleProlongationChange}
                value="oui"
              />
              <RadioButton
                id="prolongationNon"
                name="prolongation"
                label="Non"
                checked={form_Data.prolongation === "non"}
                onChange={handleProlongationChange}
                value="non"
              />
            </motion.section>
          )}

          {/* Section 8: Option de prolongation */}
          {(form_Data.prolongation === "oui" ||
            form_Data.congeOption === "ProlongationPaternite" ||
            form_Data.congeOption === "ModificationProlongationMaternite" ||
            form_Data.congeOption === "ModificationProlongationAdoption") && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              ref={prolongationOptionRef}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
                border: formErrors.prolongationOptions
                  ? "1.5px solid #ba1a1a"
                  : "none",
              }}
            >
              {sectionHeader(8, "Quelle option choisissez-vous ?")}
              <RadioButton
                id="optionA"
                name="prolongationOptions"
                label="Option B"
                checked={form_Data.prolongationOptions === "optionB"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    prolongationOptions: e.target.value,
                  }))
                }
                value="optionB"
              />
              <RadioButton
                id="optionB"
                name="prolongationOptions"
                label="Option C"
                checked={form_Data.prolongationOptions === "optionC"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    prolongationOptions: e.target.value,
                  }))
                }
                value="optionC"
              />
              <RadioButton
                id="optionD"
                name="prolongationOptions"
                label="Option D (option la plus souple)"
                checked={form_Data.prolongationOptions === "optionD"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    prolongationOptions: e.target.value,
                  }))
                }
                value="optionD"
              />
              <RadioButton
                id="optionE"
                name="prolongationOptions"
                label="Option E"
                checked={form_Data.prolongationOptions === "optionE"}
                onChange={(e) =>
                  set_Form_Data((prevData) => ({
                    ...prevData,
                    prolongationOptions: e.target.value,
                  }))
                }
                value="optionE"
              />
              {formErrors.prolongationOptions && (
                <p style={errorStyle}>{formErrors.prolongationOptions}</p>
              )}
            </motion.section>
          )}

          {/* Section 9: Dates de prolongation */}
          {form_Data.prolongationOptions !== "" && (
            <motion.section
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              ref={prolongationDateRef}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "2rem",
                marginBottom: "1.5rem",
                border: formErrors.prolongationDate
                  ? "1.5px solid #ba1a1a"
                  : "none",
              }}
            >
              {sectionHeader(
                9,
                form_Data.congeOption === "ModificationProlongationMaternite" ||
                  form_Data.congeOption === "ModificationProlongationAdoption"
                  ? "Nouvelles dates de la prolongation de votre congé sans traitement"
                  : "Dates du congé sans traitement pour la prolongation de mon congé",
              )}
              <div className="form-grid-2" style={{ gap: "1.5rem" }}>
                <div>
                  <p style={{ ...labelStyle, marginBottom: "0.6rem" }}>
                    Début du congé sans traitement
                  </p>
                  <SundayCalendarComp
                    onChange={(date) =>
                      set_Form_Data((prevData) => ({
                        ...prevData,
                        prolongationStartDate: date,
                      }))
                    }
                  />
                </div>
                <div>
                  <p style={{ ...labelStyle, marginBottom: "0.6rem" }}>
                    Fin du congé sans traitement
                  </p>
                  <SundayCalendarComp
                    onChange={(date) =>
                      set_Form_Data((prevData) => ({
                        ...prevData,
                        prolongationEndDate: date,
                      }))
                    }
                  />
                </div>
              </div>
              {formErrors.prolongationDate && (
                <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                  {formErrors.prolongationDate}
                </p>
              )}
            </motion.section>
          )}

          {/* Signature */}
          {(form_Data.prolongation ||
            form_Data.congeOption === "ModificationProlongationMaternite" ||
            form_Data.congeOption === "ProlongationPaternite" ||
            form_Data.congeOption === "ModificationProlongationAdoption") && (
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                backgroundColor: "#f2f3fe",
                borderRadius: "0.75rem",
                padding: "1.5rem 2rem",
                marginBottom: "1.5rem",
                border: formErrors.acknowledgeSignature
                  ? "1.5px solid #ba1a1a"
                  : "none",
              }}
            >
              <label
                style={{
                  display: "flex",
                  gap: "0.875rem",
                  alignItems: "flex-start",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  id="acknowledgeSignature"
                  checked={acknowledgeSignature}
                  onChange={handleAcknowledgeSignatureChange}
                  style={{
                    width: "1.25rem",
                    height: "1.25rem",
                    marginTop: "0.1rem",
                    accentColor: "#00447f",
                    flexShrink: 0,
                    cursor: "pointer",
                  }}
                />
                <span
                  style={{
                    fontSize: "0.875rem",
                    lineHeight: 1.6,
                    color: "#414751",
                  }}
                >
                  En cochant cette case, je confirme que les informations
                  fournies dans ce formulaire sont exactes et conformes à ma
                  situation. Je fais une demande officielle, laquelle sera
                  transmise aux services des ressources humaines du Centre de
                  services scolaire du Chemin-du-Roy pour traitement, et une
                  copie sera acheminée au Syndicat de l’enseignement des
                  Vieilles-Forges.{" "}
                  <strong>
                    Je comprends que le fait de cocher cette case fait office de
                    signature officielle.
                  </strong>
                </span>
              </label>
              {formErrors.acknowledgeSignature && (
                <p style={{ ...errorStyle, marginTop: "0.5rem" }}>
                  {formErrors.acknowledgeSignature}
                </p>
              )}
            </motion.div>
          )}

          {/* Email verification */}
          {acknowledgeSignature && (
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{ marginBottom: "1.5rem" }}
            >
              <EmailVerification
                apiUrl={apiUrl}
                domain={
                  apiUrl?.includes("ngrok")
                    ? ""
                    : apiUrl?.includes("localhost")
                      ? "@gmail.com"
                      : "@csscdr.gouv.qc.ca"
                }
                error={formErrors.emailVerification}
                onVerified={handleEmailVerified}
              />
              {formErrors.emailVerification && (
                <p style={errorStyle}>{formErrors.emailVerification}</p>
              )}
            </motion.div>
          )}

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: "#00447f",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.625rem",
              padding: "0.875rem 2.5rem",
              fontSize: "1rem",
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              marginBottom: "2rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {loading ? "Envoi en cours..." : "Envoyer"}
          </button>

          {submitError && (
            <div
              style={{
                marginTop: "1rem",
                padding: "1rem 1.25rem",
                backgroundColor: "#fff0f0",
                border: "1.5px solid #ba1a1a",
                borderRadius: "0.625rem",
                color: "#ba1a1a",
                fontSize: "0.9rem",
                lineHeight: 1.5,
              }}
            >
              {submitError}
            </div>
          )}
          {loading && (
            <div className="loading-overlay">
              <img src="/loading-logo.gif" alt="Loading..." />
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default CongeDroitParentaux;
